import $ from 'jquery'
import { loadScript } from '@paypal/paypal-js'

// eslint-disable-next-line no-undef
const paypalI18n = bookingHubPayPal

// eslint-disable-next-line no-undef
const pluginI18n = bookingHub

window.addEventListener('bookingHubPaymentStep', (event) => {
  const { mainEl, bookingForm, bookingId, submit, paymentMethod } = event.detail

  if (paymentMethod !== paypalI18n.methodName) return

  loadScript({
    clientId: paypalI18n.clientId,
    disableFunding: 'paylater,venmo',
    currency: pluginI18n.price.currencyCode,
  })
    .then((paypal) => {
      paypal
        .Buttons({
          createOrder: async () => {
            try {
              let orderId

              await $.ajax({
                url: pluginI18n.ajaxUrl,
                method: 'POST',
                dataType: 'json',
                data: {
                  action: 'bhub/payments/paypal/get_form',
                  _ajax_nonce: pluginI18n.nonce,
                  bookingForm,
                  bookingId,
                },
                success: (res) => {
                  if (res.success) {
                    orderId = res.data.orderId
                  } else {
                    throw new Error(res.data.message)
                  }
                },
              })

              return orderId
            } catch (err) {
              alert(err.message)
            }
          },
          onApprove: async (data) => {
            submit(data).catch((err) => {
              alert(err.data.message)
            })
          },
        })
        .render(
          mainEl.querySelector('.bhub-paypal-payment-form__iframe-handler')
        )
        .catch((error) => {
          alert('failed to render the PayPal Buttons', error)
        })
        .then(() => {
          mainEl.querySelector('.bhub-price-amount--styled').style.display =
            'block'
          mainEl.querySelector('.bhub-loader').remove()
        })
    })
    .catch((error) => {
      alert('failed to load the PayPal JS SDK script', error)
    })
})
